import {
  ADS_META_DESTINATION_TYPE_APP,
  ADS_META_DESTINATION_TYPE_APP_STORE,
  ADS_META_DESTINATION_TYPE_CATALOG,
  ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  ADS_META_DESTINATION_TYPE_NONE,
  ADS_META_DESTINATION_TYPE_ON_POST,
  ADS_META_DESTINATION_TYPE_ON_VIDEO,
  ADS_META_DESTINATION_TYPE_WEBSITE,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  ADS_META_DESTINATION_TYPE_WHATSAPP,
} from "../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_NONE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
} from "./constants";

// Translation key for each Meta ad set destination type.
export const META_DESTINATION_TYPE_TRANSLATION_KEYS = {
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_NONE_OPTION]:
    ADS_META_DESTINATION_TYPE_NONE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION]:
    ADS_META_DESTINATION_TYPE_WEBSITE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION]:
    ADS_META_DESTINATION_TYPE_WEBSITE_AND_APP,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION]:
    ADS_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION]:
    ADS_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION]:
    ADS_META_DESTINATION_TYPE_INSTAGRAM_PROFILE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION]:
    ADS_META_DESTINATION_TYPE_ON_VIDEO,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION]:
    ADS_META_DESTINATION_TYPE_ON_POST,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION]:
    ADS_META_DESTINATION_TYPE_WHATSAPP,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION]:
    ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION]:
    ADS_META_DESTINATION_TYPE_MESSAGES_ON_MESSENGER,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION]:
    ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION]:
    ADS_META_DESTINATION_TYPE_INSTANT_FORM,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION]:
    ADS_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION]:
    ADS_META_DESTINATION_TYPE_CATALOG,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION]:
    ADS_META_DESTINATION_TYPE_GOOGLE_PLAY,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION]:
    ADS_META_DESTINATION_TYPE_APP_STORE,
  [ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION]:
    ADS_META_DESTINATION_TYPE_APP,
};
